<script>
  export let item;
</script>

<div class="attachment-item">
  <div class="attachment-item__info text-micro">{item.info}</div>
  <div class="attachment-item__title">{item.title}</div>
  <a
    href={item.link}
    target="_blank"
    class="btn btn-icon link-secondary attachment-item__cta"
  >
    <i class="isax isax-arrow-down-24" />
    <span>download</span>
  </a>
</div>

<style lang="scss">
  .attachment-item {
    border: 1px solid $light-border;
    border-radius: 20px;
    padding: 5rem 4rem 3.4rem;
    min-height: 24.4rem;

    &__info {
      color: var(--royal-light);
      text-transform: uppercase;
    }

    &__title {
      border-bottom: 1px solid $light-border;
      margin-top: 1rem;
      padding-bottom: 2rem;
    }

    &__cta {
      margin-top: 2rem;

      i {
        color: var(--royal);
        font-weight: 800;
      }
      span {
        text-transform: capitalize;
        color: var(--royal-light);
      }
    }
  }
</style>
